import {useDateTimeFormatter, useFormatNumber} from 'platform/locale';

import i18n from '@dms/i18n';

import type {GridPdfExportCallback} from 'features/eag-grid';

import {createTireSetPdfData} from '../utils/createTireSetPdfData';

const PDF_FILENAME = 'tire-sets.pdf';
const BRAND = 'OMNETIC';

export function useTireSetPdfExport(): GridPdfExportCallback {
  const formatDateTime = useDateTimeFormatter();
  const formatNumber = useFormatNumber();

  return async (context, signal) => {
    signal.throwIfAborted();
    const records = createTireSetPdfData(context, {
      date: (value) => formatDateTime('dateShort', value),
      dateTime: (value) => formatDateTime('dateTimeShort', value),
      integer: (value) => formatNumber(value, 0),
    });
    const selection = i18n.t('page.datagrid.labels.numberOfSelectedRows', {
      selectedRows: records.length,
    });
    const exportedAt = formatDateTime('dateTimeShort', context.exportedAt);
    const {createTireSetPdf} = await import('../utils/createTireSetPdf');
    signal.throwIfAborted();
    const bytes = await createTireSetPdf(
      {
        title: i18n.t('page.tiresInventory.labels.tireSets'),
        brand: BRAND,
        metadata: `${selection} | ${i18n.t('general.actions.export')} ${exportedAt}`,
        records,
      },
      signal
    );
    return {bytes, filename: PDF_FILENAME};
  };
}
